import compact from "lodash/compact";
import { Experience } from "PFTypes";
import { useTranslation } from "react-i18next";

type UseCustomValueAriaLabel = {
  name: string;
  experienceLabelMap: Record<Experience, string>;
  customTypeAriaLabel?: string;
  isRequirement?: boolean;
  experience?: Experience;
  requiredExperience?: Experience;
  customClickActionText?: string;
};

export const useCustomValueAriaLabel = ({
  name,
  customTypeAriaLabel,
  isRequirement,
  experience,
  requiredExperience,
  customClickActionText,
  experienceLabelMap
}: UseCustomValueAriaLabel) => {
  const { t } = useTranslation("core", { keyPrefix: "skillRatings" });

  const clickActionText = customClickActionText ?? t("openCustomValueDetails");

  if (isRequirement) {
    const requirementOnlyExperienceText = experience ? experienceLabelMap[experience] : "";

    return compact([customTypeAriaLabel, name, requirementOnlyExperienceText, clickActionText]).join(", ");
  }

  const profileExperienceText = experience
    ? `${t("profile")}: ${experienceLabelMap[experience]}`
    : t("experienceMissing");
  const requiredExperienceText = requiredExperience
    ? `${t("required")}: ${experienceLabelMap[requiredExperience]}`
    : "";

  return compact([
    customTypeAriaLabel,
    name,
    profileExperienceText,
    requiredExperienceText,
    clickActionText
  ]).join(", ");
};
